const layout = {
  namespaced: true,
  state: {
    navCollapsed: (window.outerWidth < 920),
    header: true,
    main: true,
    aside: true,
    footer: true,
  },
  getters: {
  },
  mutations: {
    /**
     * Update the layout state
     * @param {*} state
     * @param {Object} payload - with key as layout name and value as its corresponding state
     */
    update(state, payload) {
      Object.keys(payload)
        .forEach((key) => {
          if (state[key] != null) {
            state[key] = payload[key];
          }
        });
    },
  },
};

export default layout;



// WEBPACK FOOTER //
// ./src/store/modules/layout.js